import { Flex } from '@chakra-ui/react';
import ActivityIndicator from 'components/ActivityIndicator';
import { ACTIVITIES } from 'types';
import { getEventData } from './helpers';
import { rowH } from '../DetailedStatistics';

const EventPoint = ({ type, item }: { item: any; type: ACTIVITIES }) => {
    const { left, width, duration } = getEventData(item);

    const isConvos = type === ACTIVITIES.convos;
    const isCalls = type === ACTIVITIES.calls;
    const isPickUps = type === ACTIVITIES.pickUps;
    // const isEarlyHangUps = type === ACTIVITIES.earlyHangUps;

    const w = isCalls || isPickUps ? '3px' : isConvos ? `${width}%` : undefined;

    return (
        <Flex left={`${left}%`} alignItems="center" height={rowH} position="absolute" width="100%">
            <ActivityIndicator label={isConvos && `${(duration / 60).toFixed(2)} minutes`} width={w} type={type} />
        </Flex>
    );
};

export default EventPoint;
